import { CdkScrollableModule, ScrollingModule } from "@angular/cdk/scrolling";
import { NgModule } from "@angular/core";
import { MapModule } from "~app/common/components/map/map.module";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { DependencyGraph } from "~app/common/services/cqs/DependencyGraph";
import { SharedModule } from "../shared/shared.module";
import { ArbetsorderAlertComponent } from "./arbetsorder-alert/arbetsorder-alert.component";
import { ArbetsorderAtgardComponent } from "./arbetsorder-atgard/arbetsorder-atgard.component";
import { ArbetsorderAtgardProduktionAvslutadComponent } from "./arbetsorder-atgard/produktion-avslutad/arbetsorder-atgard-produktion-avslutad.component";
import { ArbetsorderAtgardProduktionAvslutadGrotComponent } from "./arbetsorder-atgard/produktion-avslutad/grot/arbetsorder-atgard-produktion-avslutad-grot.component";
import { ArbetsorderAtgardProduktionAvslutadLevComponent } from "./arbetsorder-atgard/produktion-avslutad/lev/arbetsorder-atgard-produktion-avslutad-lev.component";
import { ArbetsorderAtgardProduktionAvslutadRvComponent } from "./arbetsorder-atgard/produktion-avslutad/rv/arbetsorder-atgard-produktion-avslutad-rv.component";
import { ArbetsorderBulkContextMenuComponent } from "./arbetsorder-bulk-context-menu/arbetsorder-bulk-context-menu.component";
import { ArbetsorderMasshanteringComponent } from "./arbetsorder-bulk-context-menu/masshantering/arbetsorder-masshantering.component";
import { ArbetsorderMasshanteringDialogComponent } from "./arbetsorder-bulk-context-menu/masshantering/masshantering-dialog/arbetsorder-masshantering-dialog.component";
import { ArbetsorderDestineringsalternativComponent } from "./arbetsorder-destineringsalternativ/arbetsorder-destineringsalternativ.component";
import { ArbetsorderDestineringsalternativManuellaComponent } from "./arbetsorder-destineringsalternativ/manuella/arbetsorder-destineringsalternativ-manuella.component";
import { ArbetsorderDrivningspunkterComponent } from "./arbetsorder-drivningspunkter/arbetsorder-drivningspunkter.component";
import { AvlaggVaginfoComponent } from "./arbetsorder-drivningspunkter/avlagg-vaginfo/avlagg-vaginfo.component";
import { ArbetsorderHandelssortimentDetailsComponent } from "./arbetsorder-handelssortiment-details/arbetsorder-handelssortiment-details.component";
import {
    ArbetsorderHandelssortimentsvalRadComponent
} from "./arbetsorder-handelssortimentsval/arbetsorder-handelssortimentsval-rad/arbetsorder-handelssortimentsval-rad.component";
import { ArbetsorderHandelssortimentsvalComponent } from "./arbetsorder-handelssortimentsval/arbetsorder-handelssortimentsval.component";
import { ArbetsorderHeaderListRowComponent } from "./arbetsorder-header-list-row/arbetsorder-header-list-row.component";
import { ArbetsorderHeaderComponent } from "./arbetsorder-header/arbetsorder-header.component";
import { ArbetsorderInfoArbetsorderAnteckningarComponent } from "./arbetsorder-info/anteckningar/arbetsorder-anteckningar/arbetsorder-info-arbetsorder-anteckningar.component";
import { ArbetsorderInfoAnteckningarComponent } from "./arbetsorder-info/anteckningar/arbetsorder-info-anteckningar.component";
import { ArbetsorderInfoAtgardAnteckningarComponent } from "./arbetsorder-info/anteckningar/atgard-anteckningar/arbetsorder-info-atgard-anteckningar.component";
import { ArbetsorderInformationComponent } from "./arbetsorder-info/arbetsorder-information.component";
import { ArbetsorderDirektutbyteComponent } from "./arbetsorder-info/direktutbyte/arbetsorder-direktutbyte.component";
import { ArbetsorderTradslagsdataComponent } from "./arbetsorder-info/direktutbyte/tradslagsdata/arbetsorder-tradslagsdata.component";
import { ArbetsorderDokumentComponent } from "./arbetsorder-info/dokument/arbetsorder-dokument.component";
import { EudrStatusComponent } from "./arbetsorder-info/EUDR/eudr-status/eudr-status.component";
import {
    ArbetsorderInfoSummaryTerminalimportComponent
} from "./arbetsorder-info/sammanfattning/arbetsorder-info-summar-terminalimport/arbetsorder-info-summary-terminalimport.component";
import { ArbetsorderInfoSummaryExternComponent } from "./arbetsorder-info/sammanfattning/arbetsorder-info-summary-extern/arbetsorder-info-summary-extern.component";
import { ArbetsorderInfoSummaryComponent } from "./arbetsorder-info/sammanfattning/arbetsorder-info-summary/arbetsorder-info-summary.component";
import { AtgardInfoSummaryComponent } from "./arbetsorder-info/sammanfattning/atgard-info-summary/atgard-info-summary.component";
import { ReturnAtgardToGissPopupComponent } from "./arbetsorder-info/sammanfattning/return-atgard-to-giss-popup/return-atgard-to-giss-popup.component";
import { ArbetsorderKontraksraderComponent } from "./arbetsorder-kontraksrader/arbetsorder-kontraksrader.component";
import { ArbetsorderListComponent } from "./arbetsorder-list/arbetsorder-list.component";
import { ArbetsorderMaskinlagComponent } from "./arbetsorder-maskinlag/arbetsorder-maskinlag.component";
import { ArbetsorderMaskinlagService } from "./arbetsorder-maskinlag/arbetsorder-maskinlag.service";
import { ArbetsorderPeriodsattPeriodComponent } from "./arbetsorder-periodsatt-period/arbetsorder-periodsatt-period.component";
import { ArbetsorderPlaneringSchedulerModule } from "./arbetsorder-planering-scheduler/arbetsorder-planering-scheduler.module";
import { ArbetsorderProduktionsdatumComponent } from "./arbetsorder-produktionsdatum/arbetsorder-produktionsdatum.component";
import { ArbetsorderProduktvalModule } from "./arbetsorder-produktval/arbetsorder-produktval.module";
import { ArbetsorderRestriktionerComponent } from "./arbetsorder-restriktioner/arbetsorder-restriktioner.component";
import { ArbetsorderSearchHybridService } from "./arbetsorder-search/arbetsorder-search-hybrid.service";
import { ArbetsorderSearchMinaFilterService } from "./arbetsorder-search/arbetsorder-search-mina-filter.service";
import { ArbetsorderSearchComponent } from "./arbetsorder-search/arbetsorder-search.component";
import { ArbetsorderSearchFilterComponent } from "./arbetsorder-search/components/arbetsorder-search-filter/arbetsorder-search-filter.component";
import { ArbetsorderSparaSokfilterComponent } from "./arbetsorder-search/components/arbetsorder-spara-sokfilter/arbetsorder-spara-sokfilter.component";
import { ArbetsorderSearchArbetsmomentComponent } from "./arbetsorder-search/filters/arbetsorder-search-arbetsmoment/arbetsorder-search-arbetsmoment.component";
import { ArbetsorderSearchGrotComponent } from "./arbetsorder-search/filters/arbetsorder-search-grot/arbetsorder-search-grot.component";
import { ArbetsorderSearchHeaderFilterComponent } from "./arbetsorder-search/filters/arbetsorder-search-header-filter/arbetsorder-search-header-filter.component";
import { ArbetsorderSearchMatningComponent } from "./arbetsorder-search/filters/arbetsorder-search-matning/arbetsorder-search-matning.component";
import { ArbetsorderSearchSkogligDataComponent } from "./arbetsorder-search/filters/arbetsorder-search-skoglig-data/arbetsorder-search-skoglig-data.component";
import { BylComponent } from "./arbetsorder-search/filters/arbetsorder-search-skoglig-data/byl/byl.component";
import {
    ArbetsorderSearchSkogligDataProduktgrupperComponent
} from "./arbetsorder-search/filters/arbetsorder-search-skoglig-data/produktgrupper/arbetsorder-search-skoglig-data-produktgrupper.component";
import {
    ArbetsorderSearchSkogligDataSkotningAvstandComponent
} from "./arbetsorder-search/filters/arbetsorder-search-skoglig-data/skotning-avstand/arbetsorder-search-skoglig-data-skotning-avstand.component";
import {
    ArbetsorderSearchSkogligDataTillganglighetComponent
} from "./arbetsorder-search/filters/arbetsorder-search-skoglig-data/tillganglighet/arbetsorder-search-skoglig-data-tillganglighet.component";
import {
    ArbetsorderSearchSkogligDataTradslagComponent
} from "./arbetsorder-search/filters/arbetsorder-search-skoglig-data/tradslag/arbetsorder-search-skoglig-data-tradslag.component";
import { ArbetsorderSearchStatusComponent } from "./arbetsorder-search/filters/arbetsorder-search-status/arbetsorder-search-status.component";
import { ArbetsorderSearchTidComponent } from "./arbetsorder-search/filters/arbetsorder-search-tid/arbetsorder-search-tid.component";
import { ArbetsorderSearchVirkeskopComponent } from "./arbetsorder-search/filters/arbetsorder-search-virkeskop/arbetsorder-search-virkeskop.component";
import { ArbetsorderSparaComponent } from "./arbetsorder-spara/arbetsorder-spara.component";
import { ArbetsorderViol3DestineringsraderComponent } from "./arbetsorder-viol3-destineringsrader/arbetsorder-viol3-destineringsrader.component";
import { ArbetsorderViol3JusteraMatningsinformationComponent } from "./arbetsorder-viol3-justera-matningsinformation/arbetsorder-viol3-justera-matningsinformation.component";
import { ArbetsorderViol3MakuleraButtonComponent } from "./arbetsorder-viol3/arbetsorder-viol3-makulera-button/arbetsorder-viol3-makulera-button.component";
import { ArbetsorderViolversionSelectorComponent } from "./arbetsorder-viol3/arbetsorder-violversion-selector/arbetsorder-violversion-selector.component";
import { ArbetsorderVirkesorderModule } from "./arbetsorder-virkesorder/arbetsorder-virkesorder.module";
import { ArbetsorderWarningPillComponent } from "./arbetsorder-warning-pill/arbetsorder-warning-pill.component";
import { MakuleraArbetsorderButtonComponent } from "./makulera-arbetsorder-button/makulera-arbetsorder-button.component";
import { MinaMaskinlagComponent } from "./mina-maskinlag/mina-maskinlag.component";
import { PlaneraDetailComponent } from "./planera-detail/planera-detail.component";
import { PlaneraAoGrotPopupComponent } from "./planera-karta/planera-ao-grot-popup/planera-ao-grot-popup.component";
import { PlaneraAoPopupComponent } from "./planera-karta/planera-ao-popup/planera-ao-popup.component";
import { PlaneraAtgardGrotPopupComponent } from "./planera-karta/planera-atgard-grot-popup/planera-atgard-grot-popup.component";
import { PlaneraAtgardPopupComponent } from "./planera-karta/planera-atgard-popup/planera-atgard-popup.component";
import { PlaneraKartaEventService } from "./planera-karta/planera-karta-event.service";
import { PlaneraKartaComponent } from "./planera-karta/planera-karta.component";
import { PlaneraSearchResultsHeaderComponent } from "./planera-search-results/header/planera-search-results-header/planera-search-results-header.component";
import { PlaneraSearchResultsComponent } from "./planera-search-results/planera-search-results.component";
import { PlaneraTabsComponent } from "./planera-tabs/planera-tabs.component";
import { PlaneraComponent } from "./planera.component";
import { PlaneringsstatusIndicatorComponent } from "./planeringsstatus-indicator/planeringsstatus-indicator.component";
import { ProduktionsmalPlanChartComponent } from "./produktionsmal/produktionsmal-plan-chart/produktionsmal-plan-chart.component";
import { ProduktionsmalPlanChartService } from "./produktionsmal/produktionsmal-plan-chart/produktionsmal-plan-chart.service";
import { ProduktionsmalPlanLegendComponent } from "./produktionsmal/produktionsmal-plan-legend/produktionsmal-plan-legend.component";
import { ProduktionsmalPlanComponent } from "./produktionsmal/produktionsmal-plan.component";
import { ProduktionsmalPlanService } from "./produktionsmal/produktionsmal-plan.service";
import { ArbetsorderKartSymbolService } from "./services/arbetsorder-kart-symbol.service";
import { ArbetsorderMediatorService } from "./services/arbetsorder-mediator.service";
import { ArbetsorderSaveService } from "./services/arbetsorder-save.service";
import { ArbetsorderSearchService } from "./services/arbetsorder-search.service";
import { PlaneraEventService } from "./services/planera-event.service";
import { PlaneraService } from "./services/planera.service";
import { SkapaArbetsorderService } from "./services/skapa-arbetsorder.service";
import { SkapaArbetsorderDialogComponent } from "./skapa-arbetsorder-dialog/skapa-arbetsorder-dialog.component";
@NgModule({
    imports: [
        RaskCommonModule,
        MapModule,
        ArbetsorderPlaneringSchedulerModule,
        CdkScrollableModule,
        ScrollingModule,
        ArbetsorderVirkesorderModule,
        ArbetsorderProduktvalModule,
        SharedModule,
        EudrStatusComponent,
        ArbetsorderSearchComponent,
        ArbetsorderSearchFilterComponent,
        ArbetsorderSearchSkogligDataComponent,
        ArbetsorderSearchArbetsmomentComponent,
        ArbetsorderSearchHeaderFilterComponent,
        ArbetsorderSearchStatusComponent,
        ArbetsorderSearchTidComponent,
        ArbetsorderSearchGrotComponent,
        ArbetsorderSearchSkogligDataTillganglighetComponent,
        ArbetsorderSearchSkogligDataProduktgrupperComponent,
        ArbetsorderSearchVirkeskopComponent,
        ArbetsorderSparaSokfilterComponent,
        ArbetsorderMaskinlagComponent,
        MinaMaskinlagComponent,
        PlaneraKartaComponent,
        ArbetsorderPeriodsattPeriodComponent,
        ArbetsorderKontraksraderComponent,
        ArbetsorderViol3DestineringsraderComponent,
        PlaneraAtgardPopupComponent,
        PlaneraAoPopupComponent,
        PlaneraAoGrotPopupComponent,
        PlaneringsstatusIndicatorComponent,
        PlaneraAtgardGrotPopupComponent,
        ArbetsorderDestineringsalternativComponent,
        ProduktionsmalPlanComponent,
        ProduktionsmalPlanChartComponent,
        ProduktionsmalPlanLegendComponent,
        PlaneraTabsComponent,
        ArbetsorderAtgardComponent,
        ArbetsorderAtgardProduktionAvslutadComponent,
        ArbetsorderAtgardProduktionAvslutadRvComponent,
        ArbetsorderAtgardProduktionAvslutadGrotComponent,
        ArbetsorderSearchMatningComponent,
        ArbetsorderAtgardProduktionAvslutadLevComponent,
        ArbetsorderDrivningspunkterComponent,
        MakuleraArbetsorderButtonComponent,
        ArbetsorderHandelssortimentDetailsComponent,
        ArbetsorderMasshanteringComponent,
        ArbetsorderMasshanteringDialogComponent,
        ArbetsorderBulkContextMenuComponent,
        ArbetsorderHeaderListRowComponent,
        ArbetsorderHeaderComponent,
        ArbetsorderDestineringsalternativManuellaComponent,
        ArbetsorderViol3JusteraMatningsinformationComponent,
        ArbetsorderListComponent,
        ArbetsorderAlertComponent,
        ArbetsorderProduktionsdatumComponent,
        ArbetsorderTradslagsdataComponent,
        PlaneraComponent,
        PlaneraDetailComponent,
        PlaneraSearchResultsComponent,
        ArbetsorderViolversionSelectorComponent,
        PlaneraSearchResultsHeaderComponent,
        ArbetsorderInformationComponent,
        AtgardInfoSummaryComponent,
        ArbetsorderInfoSummaryComponent,
        ArbetsorderInfoAnteckningarComponent,
        ArbetsorderInfoAtgardAnteckningarComponent,
        ArbetsorderInfoArbetsorderAnteckningarComponent,
        ArbetsorderDokumentComponent,
        ArbetsorderDirektutbyteComponent,
        ArbetsorderDestineringsalternativComponent,
        ArbetsorderSparaComponent,
        ArbetsorderViol3MakuleraButtonComponent,
        SkapaArbetsorderDialogComponent,
        ArbetsorderInfoSummaryTerminalimportComponent,
        ArbetsorderHandelssortimentsvalComponent,
        ArbetsorderHandelssortimentsvalRadComponent,
        ReturnAtgardToGissPopupComponent,
        ArbetsorderInfoSummaryExternComponent,
        ArbetsorderSearchSkogligDataTradslagComponent,
        ArbetsorderWarningPillComponent,
        ArbetsorderSearchSkogligDataSkotningAvstandComponent,
        BylComponent,
        AvlaggVaginfoComponent,
        ArbetsorderRestriktionerComponent
    ],
    exports: [EudrStatusComponent],
    providers: [
        ArbetsorderSearchService,
        ArbetsorderSearchHybridService,
        ArbetsorderSearchMinaFilterService,
        ArbetsorderMaskinlagService,
        PlaneraKartaEventService,
        ProduktionsmalPlanService,
        ProduktionsmalPlanChartService,
        ArbetsorderKartSymbolService,
        PlaneraService,
        PlaneraEventService,
        ArbetsorderMediatorService,
        ArbetsorderSaveService,
        SkapaArbetsorderService
    ]
})
export class PlaneraModule { }
DependencyGraph.init();
